import * as config from './environment.stab/production-chatcast-jp';
export const configForCurrentEnv = config.default;
